import React from 'react';

/**
 * The one card every settings surface uses.
 *
 * Settings had grown three parallel card systems — `.modern-card` (company
 * settings, global SCSS), `.user-settings__card` (user settings) and
 * `.user-section`/`.user-card` (defined only in an inline <style> inside
 * CompanySettings.jsx) — with different radii, borders, heading sizes and
 * padding for the same job. `.modern-card` is the survivor: it is global,
 * already the majority, and matches the rest of the app.
 *
 * Titles are 1rem/600 next to a 16px icon. The old pairing was 24px icon +
 * 1.125rem text, which put more weight on the decoration than on the label it
 * decorates; `.section-title svg` in _modern-card.scss enforces the icon size
 * so it cannot drift back.
 */
const SettingsCard = ({
  // Anchor id — settings deep links (…/settings/security#losenord) and
  // useHashScroll target these.
  id,
  icon: Icon,
  title,
  subtitle,
  // Buttons that act on the whole card ("Skapa ny mall", "Spara"). Right edge
  // of the header.
  actions,
  className = '',
  children,
}) => (
  <div className={`modern-card ${className}`.trim()} id={id}>
    {(title || actions) && (
      <div className="modern-card-header">
        <div>
          {title && (
            <h2 className="section-title">
              {Icon && <Icon size={16} strokeWidth={2} aria-hidden="true" />}
              {title}
            </h2>
          )}
          {subtitle && <p className="section-subtitle">{subtitle}</p>}
        </div>
        {actions && <div className="action-buttons">{actions}</div>}
      </div>
    )}
    <div className="modern-card-body">{children}</div>
  </div>
);

export default SettingsCard;
